export default __webpack_public_path__ + "static/media/Helm of Tribulation.06d8621b.jpg";